import classNames from 'classnames';
import { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

// Store.
import { currentContextualOrg, isBoardUserSelector, userProfileSelector } from 'store/user/selectors';

// Styles.
import styles from './DashboardGreeting.module.scss';

interface IDashboardGreetingProps {
  className?: string;
}

export const DashboardGreeting = (props: IDashboardGreetingProps): ReactElement => {
  const { className } = props;

  // Selectors.
  const { firstName } = useSelector(userProfileSelector);
  const { businessId, organizationName } = useSelector(currentContextualOrg);
  const isBoardUser: boolean = useSelector(isBoardUserSelector);

  return (
    <section className={classNames(styles.greeting, className)}>
      <h1 className={styles.title}>Hello, {firstName}</h1>
      <p className={styles.info}>
        {organizationName} | Organization ID: {businessId}
      </p>
      {!isBoardUser && (
        <nav className={styles.navigation}>
          <ul>
            <li>
              <Link to="/dashboard/summary">Program Summary</Link>
            </li>
            <li>
              <Link to="/dashboard/agreement">Agreement Page</Link>
            </li>
          </ul>
        </nav>
      )}
    </section>
  );
};
